"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("../../../node_modules/graphql-tag/lib/index.js").gql`
    query getRetailCollectionsService($userId: Int!) {
        retailCollections(condition: { userId: $userId }) {
            nodes {
                label
                lotNumber
                id: retailCollectionId
                inventoryItems {
                    nodes {
                        modelNumber
                        serialNumber
                        id: retailCollectionInventoryItemId
                    }
                }
            }
        }
    }
`;exports.getRetailCollections=e;
//# sourceMappingURL=queries.js.map
